import { connect } from "react-redux";
import { saveFile, fetchFiles, resetFiles, fetchInfo } from "../store/actions/files"
import { showLoader, hideLoader } from "../store/actions/loader"
import { showAlert } from "../store/actions/alert"
import Selection from '../components/files/Selection';
import List from '../components/files/List';
import withAuth from '../hocs/withAuth';

function mapStateToProps(state, ownProps) {
  return {
    errors: state.errors,
    user: state.currentUser.user,
    files: state.files,
    userData: state.currentUser.user,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchAll: (query) => {
      return dispatch(fetchFiles({
        ...query,
        userId: query.userId ? query.userId : localStorage.getItem('id'),
        platform: "web",
      }));
    },
    fetchInfo: (id) => {
      return dispatch(fetchInfo(id));
    },
    resetFiles: () => {
      return dispatch(resetFiles())
    },
    addFile: (fileMeta) => {
      return dispatch(saveFile(fileMeta));
    },
    showLoader: () => {
      return dispatch(showLoader());
    },
    hideLoader: () => {
      return dispatch(hideLoader());
    },
    showAlert: (msg) => {
      return dispatch(showAlert(msg));
    }
  }
}

export const FileSelection = withAuth(connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(Selection));
export const MediaLibrary = withAuth(connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(List));



// WEBPACK FOOTER //
// ./src/containers/Files.js